import React, { useEffect, useState } from "react";

const logoList = [
  {
    href: "https://www.autodesk.org/",
    companyName: "Autodesk Foundation",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/autodesk-bw.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://greentownlabs.com/",
    companyName: "Greentown Labs",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/greentown-labs.png")
        .default,
    logoWidth: "85",
  },
  {
    href: "https://corporatefinanceinstitute.com/",
    companyName: "Corporate Finance Institute",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/corporate-finance-institute.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://eclipse.vc/",
    companyName: "Eclipse Ventures",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/eclipse-ventures.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://thegbi.org/",
    companyName: "GBI",
    logoPath: require("../images/logos-customer/1-client-logo-panel/gbi_bw.png")
      .default,
    logoWidth: "125",
  },
  {
    href: "https://tideline.com/",
    companyName: "Tideline",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/tideline.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://environment.virginia.edu/",
    companyName: "UVA Environmental Institute",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/EI_vertical_bw.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://www.forwardimpact.how/",
    companyName: "Project FRAME",
    logoPath: require("../images/logos-customer/1-client-logo-panel/frame.png")
      .default,
    logoWidth: "100",
  },
  {
    href: "https://www.callahancp.com/",
    companyName: "Callahan Capital Partners",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/callahan-capital-partners-bw.png")
        .default,
    logoWidth: "175",
  },
  {
    href: "https://www.missionfrommars.ca/",
    companyName: "MaRS",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/mars-bw.png")
        .default,
    logoWidth: "150",
  },
  {
    href: "https://primecoalition.org/",
    companyName: "Prime",
    logoPath: require("../images/logos-customer/1-client-logo-panel/prime.png")
      .default,
    logoWidth: "200",
  },
  {
    href: "https://grenovasolutions.com/",
    companyName: "Grenova",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/grenova-bw.png")
        .default,
    logoWidth: "250",
  },
  {
    href: "https://www.righthererightnow.global/",
    companyName: "Right Here Right Now",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/righthere.png")
        .default,
    logoWidth: "190",
  },
  {
    href: "https://volta.vc/",
    companyName: "Volta Energy Technologies",
    logoPath:
      require("../images/logos-customer/1-client-logo-panel/volta-bw.png")
        .default,
    logoWidth: "150",
  },
];

function CustomerLogosBanner() {
  const [visibleLogos, setVisibleLogos] = useState([]);

  useEffect(() => {
    // Start with the first 8 logos
    setVisibleLogos(logoList.slice(0, 8));

    let startIndex = 8;

    const swapLogos = () => {
      for (let i = 0; i < 8; i++) {
        setTimeout(() => {
          const logoCell = document.querySelectorAll(".logo-cell")[i];

          if (logoCell) {
            // Apply flip-out animation to the current logo
            logoCell.classList.add("flip-out");

            setTimeout(() => {
              // After the flip-out animation, update the logo
              setVisibleLogos((prevLogos) => {
                const newLogos = [...prevLogos];
                const nextIndex = (startIndex + i) % logoList.length;
                newLogos[i] = logoList[nextIndex];
                return newLogos;
              });

              // Remove flip-out and apply flip-in animation for the new logo
              logoCell.classList.remove("flip-out");
              void logoCell.offsetWidth; // Trigger a reflow to ensure the animation restarts
              logoCell.classList.add("flip-in");
            }, 300); // Duration of the flip-out animation
          }
        }, i * 200); // Delay each swap by 200ms to create the wave effect
      }

      startIndex = (startIndex + 8) % logoList.length;
    };

    const interval = setInterval(swapLogos, 5000); // Swap every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative">
      <div className="relative my-4 max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-4 md:py-4">
          {/* Section header */}
          <div className="max-w-5xl mx-auto text-center md:pb-4">
            <div className="flex items-center py-6">
              <h2 className="text-sm text-rhoBlueDark-700 mb-0 text-left leading-none">
                Trusted by the World's Leading Innovators
              </h2>
              <div className="flex-1 border-t border-dashed border-rhoBlueDark-700 ml-4"></div>
            </div>
            {/* LOGO GRID */}
            <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
              {visibleLogos.map((logo, index) => (
                <div
                  key={index}
                  className="relative logo-cell h-[150px] flex items-center justify-center p-4"
                >
                  <img
                    src={logo.logoPath}
                    alt={logo.companyName}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CustomerLogosBanner;
